import { render, staticRenderFns } from "./CollapsedPaystubReport.vue?vue&type=template&id=fb0daaf2&scoped=true&"
import script from "./CollapsedPaystubReport.vue?vue&type=script&lang=ts&"
export * from "./CollapsedPaystubReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0daaf2",
  null
  
)

export default component.exports